interface Props { names: string[] }

export function TypingIndicator({ names }: Props) {
  if (!names.length) return null

  const hasNames = names.some((n) => n !== '')
  const label = !hasNames
    ? 'печатает...'
    : names.length === 1
      ? `${names[0]} печатает...`
      : names.length === 2
        ? `${names[0]} и ${names[1]} печатают...`
        : `печатают ${names.length} участника...`

  return (
    <div className="flex items-center gap-1.5 px-4 py-1 text-txt-secondary text-xs select-none">
      <span className="flex items-center gap-0.5 mt-0.5">
        {[0, 1, 2].map((i) => (
          <span
            key={i}
            className="inline-block w-1.5 h-1.5 rounded-full bg-txt-meta animate-typing-dot"
            style={{ animationDelay: `${i * 0.2}s` }}
          />
        ))}
      </span>
      <span>{label}</span>
    </div>
  )
}
